import PolygonHandle from './PolygonHandle';

export default function DraftHandles({ points }: { points: number[] }) {
	return (
		<>
			{points.map((_, i) => {
				if (i % 2 !== 0) return null;

				const x = points[i];
				const y = points[i + 1];

				return (
					<PolygonHandle
						key={`${x}-${y}-${i}`}
						x={x}
						y={y}
						listening={false}
					/>
				);
			})}
		</>
	);
}
